import { useEffect } from "react";
import { fetchBlogsAsync } from "../../../../../apis/blogs/blogs";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../store/store";
import { Link } from "react-router-dom";
import BlogCard from "../../Blogs/BlogCard";

const Blogs = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { blogs, loading, error } = useSelector(
    (state: RootState) => state.blogs
  );

  useEffect(() => {
    if (blogs.length === 0) {
      dispatch(fetchBlogsAsync());
    }
  }, [blogs.length, dispatch]);

  return (
    <div className="flex flex-col gap-4 w-full px-5 lg:px-20">
      <div className="flex items-center w-full justify-center">
        <div className="flex items-start gap-4 md:items-center flex-col md:flex-row justify-between max-w-[1106px] w-full">
          <h4 className="text-textBlack text-[22px] lg:text-[36px] font-semibold">
            Insights and Stories
          </h4>
          {!loading && blogs.length > 0 && (
            <Link to="/insights-stories">
              <button className="outline-button shadow-custom uppercase">
                Load more
              </button>
            </Link>
          )}
        </div>
      </div>
      <div className="w-full items-center justify-center flex">
        <div className=" max-w-[1106px] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {blogs &&
            blogs.length > 0 &&
            blogs
              .slice(0, 3)
              .map((blog, i) => <BlogCard key={i} blog={blog} />)}
        </div>
      </div>
    </div>
  );
};

export default Blogs;
